import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";

import { LoginAllFilesInOne } from "@/assets/images";

const AllYourFilesInOne: FC = () => {
    const { t } = useTranslation();

    return (
        <Stack direction="row" justifyContent="space-around" alignItems="center" pb={4} mt={{ xs: 2, sm: 16 }}>
            <Box width={{ xs: "140px", sm: "200px", md: "366px" }} height="auto" component={LoginAllFilesInOne} />
            <Box width={{ xs: "340px", sm: "484px" }}>
                <Typography variant="h2">{t("Login.AllFilesInOne.Title")}</Typography>
                <Typography color="var(--color-grey-900)" lineHeight="20px" fontSize="var(--size-16)" mt={2}>
                    {t("Login.AllFilesInOne.Message")}
                </Typography>
            </Box>
        </Stack>
    );
};

export default AllYourFilesInOne;
